/**
 * ธนาคารในประเทศไทย — ordered by Bank of Thailand bank code (001, 002, 004 …),
 * which is the order the list is conventionally shown in. Stored on the seller
 * master as plain text in `bank`, so these strings ARE the persisted values —
 * renaming an entry orphans existing records.
 */
export const THAI_BANKS = [
  'ธนาคารแห่งประเทศไทย',
  'กรุงเทพ',
  'กสิกรไทย',
  'กรุงไทย',
  'เจพีมอร์แกน เชส',
  'โอซีบีซี',
  'ทหารไทยธนชาต',
  'ไทยพาณิชย์',
  'ซิตี้แบงก์',
  'ซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น',
  'สแตนดาร์ดชาร์เตอร์ด (ไทย)',
  'ซีไอเอ็มบี',
  'อาร์ เอช บี จำกัด',
  'ยูโอบี',
  'กรุงศรีอยุธยา',
  'เมกะ สากลพาณิชย์ จำกัด',
  'แห่งอเมริกา เนชั่นแนล แอสโซซิเอชั่น',
  'อินเดียน โอเวอร์ซีส์',
  'ออมสิน',
  'ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด',
  'ดอยซ์แบงก์',
  'อาคารสงเคราะห์',
  'เพื่อการเกษตรและสหกรณ์',
  'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย',
  'มิซูโฮ คอร์ปอเรต จำกัด',
  'บีเอ็นพี พารีบาส์ สาขากรุงเทพฯ',
  'ธนาคารแห่งประเทศจีน (ไทย)',
  'ธนชาต',
  'อิสลามแห่งประเทศไทย',
  'ทิสโก้',
  'เกียรตินาคิน',
  'ไอซีบีซี (ไทย)',
  'ไทยเครดิต เพื่อรายย่อย',
  'แลนด์แอนด์เฮ้าส์',
  'เอเอ็นแซด (ไทย)',
  'ซูมิโตโม มิตซุย ทรัสต์ (ไทย)',
]
